import store from '@/store';

// Components
import Main from '@/components/Main';
import MainKind from '@/components/kind/MainKind';
import PrivacyPolicy from '@/components/static/PrivacyPolicy';
import Terms from '@/components/static/Terms';
import Contact from '@/components/contact/Contact';
import SearchKodate from '@/components/search/kodate/SearchKodate';
import DetailKodate from '@/components/detail/Kodate';
import SearchSchoolDistricts from '@/components/search/school-districts/SearchSchoolDistricts';
// import FavoriteNew from '@/components/favorite/FavoriteNew';
import FavoriteNew from '@/components/favorite/FavoriteContentsNew';

import ViewHistory from '@/components/history/view/ViewHistory';
import SearchHistory from '@/components/history/search/SearchHistory';
import MemberRegist from '@/components/member/Regist';
import MemberSignup from '@/components/member/Signup';
// import MemberLogin from '@/components/member/Login';
import ReceiveLogin from '@/components/member/ReceiveLogin';
import MemberDelete from '@/components/member/Delete';
// import MemberResetPassword from '@/components/member/ResetPassword';
import ReceiveResetPassword from '@/components/member/ReceiveResetPassword';
import Mypage from '@/components/mypage/MyPage';
import Reservation from '@/components/reservation/reservation/Reservation';
import DocumentRequest from '@/components/reservation/document-request/DocumentRequest';
import Maintenance from '@/components/Maintenance/Maintenance';
import ERR from '@/components/Maintenance/Error';
import Admin from '@/components/Admin';
import AssetList from '@/components/parts/AssetList';
import Templates from '@/components/templates/CommonLayoutTemplate';

import Signout from '@/components/common/Signout';

import Router from 'vue-router';
import Vue from 'vue';
import { checkSession } from '../utils/auth';


const router = new Router({
  mode: 'history',
  routes: [
    // root
    {
      path: '/',
      name: 'Main',
      component: Main,
    },
    {
      path: '/index.html',
      name: 'Main',
      component: Main,
      meta: {
        canonical: '/',
      },
    },
    {
      path: '/signout',
      name: 'Signout',
      component: Signout,
    },
    // static
    {
      path: '/privacypolicy',
      name: 'Privacypolicy',
      component: PrivacyPolicy,
    },
    {
      path: '/terms',
      name: 'Terms',
      component: Terms,
    },
    // kind
    // kodate
    {
      path: '/kodate/',
      name: 'MainKind',
      component: MainKind,
      meta: {
        kind: 0,
      },
    },
    {
      path: '/kodate/shinchiku/',
      name: 'MainShinchiku',
      component: MainKind,
      meta: {
        kind: 1,
      },
    },
    {
      path: '/kodate/chuko/',
      name: 'MainChuko',
      component: MainKind,
      meta: {
        kind: 2,
      },
    },
    // search
    // all
    {
      path: '/kodate/area/:prefecture',
      name: 'KodatePrefecture',
      component: SearchKodate,
      meta: {
        hideFullFooter: true,
        kind: 0,
      },
    },
    {
      path: '/kodate/area/:prefecture/:city',
      name: 'KodateCity',
      component: SearchKodate,
      meta: {
        hideFullFooter: true,
        kind: 0,
      },
    },
    {
      path: '/kodate/area/:prefecture/:city/:town',
      name: 'KodateTown',
      component: SearchKodate,
      meta: {
        hideFullFooter: true,
        kind: 0,
      },
    },

    // shinchiku
    {
      path: '/kodate/shinchiku/area/:prefecture',
      name: 'KodatePrefectureShinchiku',
      component: SearchKodate,
      meta: {
        hideFullFooter: true,
        kind: 1,
      },
    },
    {
      path: '/kodate/shinchiku/area/:prefecture/:city',
      name: 'KodateCityShinchiku',
      component: SearchKodate,
      meta: {
        hideFullFooter: true,
        kind: 1,
      },
    },
    {
      path: '/kodate/shinchiku/area/:prefecture/:city/:town',
      name: 'KodateTownShinchiku',
      component: SearchKodate,
      meta: {
        hideFullFooter: true,
        kind: 1,
      },
    },
    // chuko
    {
      path: '/kodate/chuko/area/:prefecture',
      name: 'KodatePrefectureChuko',
      component: SearchKodate,
      meta: {
        hideFullFooter: true,
        kind: 2,
      },
    },
    {
      path: '/kodate/chuko/area/:prefecture/:city',
      name: 'KodateCityChuko',
      component: SearchKodate,
      meta: {
        hideFullFooter: true,
        kind: 2,
      },
    },
    {
      path: '/kodate/chuko/area/:prefecture/:city/:town',
      name: 'KodateTownChuko',
      component: SearchKodate,
      meta: {
        hideFullFooter: true,
        kind: 2,
      },
    },
    // detail
    {
      path: '/kodate/:propertyid',
      name: 'kodateDetail',
      component: DetailKodate,
    },

    // school
    {
      path: '/school-districts/:prefecture/:city',
      name: 'SchoolDistrictsCity',
      component: SearchSchoolDistricts,
      meta: {
        hideFullFooter: true,
      },
    },

    // bookmark
    // {
    //   path: '/bookmark',
    //   name: 'Favorite',
    //   component: Favorite,
    // },
    {
      path: '/bookmark',
      name: 'FavoriteNew',
      component: FavoriteNew,
      meta: {
        hideFullFooter: false,
      },
    },
    // history
    {
      path: '/history/view',
      name: 'ViewHistory',
      component: ViewHistory,
    },
    {
      path: '/history/search',
      name: 'SearchHistory',
      component: SearchHistory,
    },

    // user
    {
      path: '/member/signup',
      name: 'MemberRegist',
      component: MemberSignup,
      meta: {
        notSignIn: true,
      },
    },

    {
      path: '/member/regist',
      name: 'MemberRegist',
      component: MemberRegist,
      meta: {
        notSignIn: true,
      },
    },
    // {
    //   path: '/member/login',
    //   name: 'MemberLogin',
    //   component: MemberLogin,
    //   meta: {
    //     notSignIn: true,
    //   },
    // },
    {
      path: '/member/login',
      name: 'ReceiveLogin',
      component: ReceiveLogin,
      meta: {
        notSignIn: true,
        skipAuthCheck: true,
      },
    },
    {
      path: '/member/delete',
      name: 'MemberDelete',
      component: MemberDelete,
    },
    // {
    //   path: '/member/password',
    //   name: 'MemberResetPassword',
    //   component: MemberResetPassword,
    // },
    {
      path: '/member/password',
      name: 'ReceiveResetPassword',
      component: ReceiveResetPassword,
    },
    // mypage
    {
      path: '/mypage',
      name: 'Mypage',
      component: Mypage,
    },
    // contact
    {
      path: '/contact',
      name: 'Contact',
      component: Contact,
    },
    // reservation
    {
      path: '/reservation/:propertyid',
      name: 'reservation',
      component: Reservation,
    },
    // document request
    {
      path: '/document-request/:propertyid',
      name: 'document-request',
      component: DocumentRequest,
    },
    // maintenance
    {
      path: '/401',
      name: 'ErrorUnauthed',
      component: ERR,
    },
    {
      path: '*', // WIP
      name: 'ErrorNotFound',
      component: ERR,
    },
    {
      path: '/301',
      name: 'RedirectPermanently',
      component: Maintenance,
    },
    {
      path: '/302',
      name: 'RedirectInstantly',
      component: Maintenance,
    },
    // admin
    {
      path: '/admin',
      name: 'Admin',
      component: Admin,
    },
    {
      path: '/admin/assets',
      name: 'AssetList',
      component: AssetList,
    },
    {
      path: '/admin/templates',
      name: 'Templates',
      component: Templates,
    },
  ],
});

Vue.use(Router);

async function setUser() {
  try {
    const user = await checkSession();
    if (store.getters.user && user) {
      return;
    }

    if (user) {
      store.commit('setUser', user);
    }
  } catch (e) {
    store.commit('setUser', null);
  }
  store.commit('userReady');
}


// リダイレクト設定
router.beforeResolve(async (to, from, next) => {
  if (to.matched.some(record => record.meta.skipAuthCheck)) {
    return next();
  }
  await setUser();
  if (to.matched.some(record => record.meta.notSignIn)) {
    if (store.state.user) {
      return next({
        path: '/',
      });
    }
    return next();
  }
  return next();
});


export default router;
